export const QuestionIcon = (props) => {
	const { className, size = 32, margin } = props;

	return (
		<img src="gif/question.gif" width={size} height={size} className={className} style={{ margin }} />
	);
};